// Number fields must never change value because someone scrolled.
//
// The spinner arrows are already hidden in CSS, but desktop browsers still
// turn a mouse-wheel or trackpad scroll over a FOCUSED <input type="number">
// into a value change: type 100, brush the trackpad, read 99.87. Blurring
// the field at the first wheel event keeps the value and lets the page
// scroll as the user intended. Touch devices send no wheel events, so
// phones and tablets are untouched.
document.addEventListener("wheel", (event) => {
  const active = document.activeElement
  if (active && active.tagName === "INPUT" && active.type === "number" && active.contains(event.target)) {
    active.blur()
  }
}, { passive: true })
